import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatTelInput } from 'mat-tel-input'

import { CustomFieldModule } from '../custom-field'
import { PhoneFieldComponent } from './phone-field.component'

@NgModule({
  imports: [
    CommonModule,
    CustomFieldModule,
    FormsModule,
    MatTelInput,
    MatFormFieldModule,
  ],
  declarations: [PhoneFieldComponent],
  exports: [PhoneFieldComponent],
})
export class PhoneFieldModule {}
